import * as Popper from "@popperjs/core";
import "bootstrap";

window.Popper = Popper;
